import { Conversation } from '@11labs/client';

//faq toggle
document.querySelectorAll('.faq-question').forEach(question => {
    question.addEventListener('click', () => {
        const faqItem = question.parentElement;
  
        // Toggle the active class
        faqItem.classList.toggle('active');
        const toggle = question.querySelector('.plus');
        toggle.textContent = faqItem.classList.contains('active') ? '-' : '+';
  
    });
});



// hover steps SA
const steps = document.querySelectorAll('.sa-steps');
// steps.forEach(step => {
//     step.addEventListener('mouseover', () => {
//         steps.forEach(otherStep => {
//             if (otherStep !== step) {
//                 otherStep.classList.add('greyed-out');
//             }
//         });
//     });
//     step.addEventListener('mouseout', () => {
//         steps.forEach(otherStep => {
//             otherStep.classList.remove('greyed-out');
//         });
//     });
// });

document.addEventListener('DOMContentLoaded', function() {

    //MOBILE MENU
    const menuButton = document.querySelector('.mobile-menu-button');
    const mobileMenu = document.querySelector('.mobile-menu');
    const mobileNavLinks = document.querySelectorAll('.mobile-nav-link');

    menuButton.addEventListener('click', function() {
        menuButton.classList.toggle('active');
        mobileMenu.classList.toggle('active');
        document.body.style.overflow = mobileMenu.classList.contains('active') ? 'hidden' : '';
    });

    // Close menu when clicking a link
    mobileNavLinks.forEach(link => {
        link.addEventListener('click', function() {
            menuButton.classList.remove('active');
            mobileMenu.classList.remove('active');
            document.body.style.overflow = '';
        });
    });

    // Get all nav links that have href="#comparatif"
    const comparatifLinks = document.querySelectorAll('a[href="#Examples"]');
    const tryCallButton = document.querySelector('.try-call-button');
    
    comparatifLinks.forEach(link => {
        link.addEventListener('click', function(e) {
            console.log("animation pulse")
            // Add the animation class to the try-call-button
            tryCallButton.classList.add('pulse-animation');
            
            // Remove the animation class after it completes
            setTimeout(() => {
                tryCallButton.classList.remove('pulse-animation');
            }, 500); // 500ms matches the animation duration
        });
    });


    // Contact selection functionality
    const contactItems = document.querySelectorAll('.contact-item');
    const simulateCallButton = document.querySelector('.try-call-button');
    let selectedContact = contactItems[0]; // First contact is selected by default
    let currentConversation = null;  // Track current conversation
    let microphoneStream = null;  // Add this to track the microphone stream

    const agentIds = {
        'Léa': '1HSunjUKmxObEEKiGZEt',
        'Thomas': 'DEQSnqBqd24M3YHkPP0n',
        'Eric': '2yGIDulY0jezyXQFXuHI'
    };

    contactItems.forEach(contact => {
        contact.addEventListener('click', function() {
            selectedContact.classList.remove('selected');
            this.classList.add('selected');
            selectedContact = this;
        });
    });

    document.querySelector('.try-call-button').addEventListener('click', async function() {
        console.log("button pressed");
        
        try {
            // If there's an active conversation, end it
            if (currentConversation) {
                await currentConversation.endSession();
                // Stop the stored microphone stream
                if (microphoneStream) {
                    microphoneStream.getTracks().forEach(track => track.stop());
                    microphoneStream = null;
                }
                
                currentConversation = null;
                this.innerHTML = `
                    <div class="phone-circle">
                        <img src="https://assets.iallofrance.com/assets/phone-white.svg" alt="Phone" width="16">
                    </div>
                    Simuler un appel
                `;
                this.classList.remove('active');
                return;
            }

            // Request microphone permission and store the stream
            microphoneStream = await navigator.mediaDevices.getUserMedia({ audio: true });
            
            // Get selected agent ID
            const contactName = selectedContact.querySelector('.contact-name').textContent;
            const agentId = agentIds[contactName];
            
            // Start new conversation
            currentConversation = await Conversation.startSession({
                agentId: agentId,
                onDisconnect: () => {
                    // Reset button state when conversation ends
                    this.innerHTML = `
                        <div class="phone-circle">
                            <img src="https://assets.iallofrance.com/assets/phone-white.svg" alt="Phone" width="16">
                        </div>
                        Simuler un appel
                    `;
                    this.classList.remove('active');
                    console.log("conversation ended");
                    currentConversation = null;
                }
            });
            
            // Update button state
            this.innerHTML = `
                <div class="phone-circle-end">
                    <img src="/assets/phone-white.svg" alt="Phone" width="16">
                </div>
                Terminer l'appel
            `;
            this.classList.add('active');

        } catch (error) {
            console.error("Error:", error);
            alert("Une erreur s'est produite. Veuillez réessayer.");
        }
    });

    const emailForm = document.getElementById('email-form');
    if (emailForm) {
        emailForm.addEventListener('submit', function(e) {
            e.preventDefault();
            const email = document.getElementById('email-input').value;
            sessionStorage.setItem('prefilledEmail', email); // Save email for login page
            window.location.href = '/connexion';
        });
    }

    // FIgure
      // JS for SA structure
      
      const figureIcons = document.querySelectorAll('.figure-icon');
      const svg = document.querySelector('.rainbow-lines');
      const iconGroups = [
          [0, 1, 2, 4],
          [4, 5],
          [4, 6, 7, 8]
      ];

      let currentIconGroupIndex = 0;
      
      // Refactored connections as an array for predictable order
      const connections = [
          { from: 1, to: 5 },
          { from: 2, to: 5 },
          { from: 3, to: 5 },
        //   { from: 4, to: 5 },

          { from: 5, to: 6 },

          { from: 5, to: 7 },
          { from: 5, to: 8 },
          { from: 5, to: 9 }
      ];
      
      const lineGroups = [
          [0, 1, 2],              // Lines 1-4
          [3],                 // Lines 5-7
          [4, 5, 6] 
      ];
      let currentLineGroupIndex = 0;
      
      // Mapping steps to icons
      const stepIconMapping = [
        [0, 1, 2, 4],      // 1st step
        [4, 6], 
        [4, 5],               // 2nd step
        [4],         // 3rd step
      ];
      
      // Get the center position of an element relative to the SVG container
      function getCenterPosition(element) {
          const rect = element.getBoundingClientRect();
          const svgRect = svg.getBoundingClientRect();
          return {
              x: rect.left + rect.width / 2 - svgRect.left,
              y: rect.top + rect.height / 2 - svgRect.top
          };
      }
      
      // Draw a rainbow line between two points
      function drawRainbowLine(start, end) {
        const path = document.createElementNS("http://www.w3.org/2000/svg", "path");
        path.setAttribute("d", `M${start.x},${start.y} L${end.x},${end.y}`);
        path.setAttribute("stroke-width", "2");
        path.setAttribute("fill", "none");
      
        let hue = 0; // Initial hue value
      
        setInterval(() => {
            const color = `hsl(${hue}, 100%, 50%)`; // HSL color format for rainbow effect
            path.setAttribute("stroke", color);
            hue = (hue + 1) % 360; // Small increment for slower transitions
        }, 50); // Slower interval for smoother effect
      
        return path;
      }
      
      // Initialize line elements and colors
      const lineElements = [];
      
      // Function to generate all lines
      function generateLines() {
          // Remove existing lines
          lineElements.forEach(line => svg.removeChild(line));
          lineElements.length = 0; // Clear the array
      
          connections.forEach((connection) => {
              const fromIcon = figureIcons[connection.from - 1]; // Convert 1-based index to 0-based
              const toIcon = figureIcons[connection.to - 1];
              const fromPosition = getCenterPosition(fromIcon);
              const toPosition = getCenterPosition(toIcon);
      
              // Create the line and store it
              const line = drawRainbowLine(fromPosition, toPosition);
              line.style.opacity = 0; // Hide initially
              svg.appendChild(line);
              lineElements.push(line);
          });
      }
      
      // Function to update the display based on current indices
      // Keep track of active icons in the current cycle
      let cycleTimeout = null;
      let activeIconIndices = [];
      
      // Update the display function to store active icons
      function updateDisplay() {
          // Turn off all icons and lines
          figureIcons.forEach(icon => toggleState(icon, false));
          lineElements.forEach(line => (line.style.opacity = 0));
      
          // Activate icons in the current group
          const currentIconsGroup = iconGroups[currentIconGroupIndex];
          activeIconIndices = currentIconsGroup.slice(); // Store active indices
          currentIconsGroup.forEach(iconIndex => {
              const icon = figureIcons[iconIndex];
              toggleState(icon, true);
          });
      
          // Activate lines in the current group
          const currentLinesGroup = lineGroups[currentLineGroupIndex];
          currentLinesGroup.forEach(lineIndex => {
              if (lineElements[lineIndex]) {
                  lineElements[lineIndex].style.opacity = 1;
              }
          });
      }
      
      // Add hover event listeners to each icon
      figureIcons.forEach((icon, index) => {
          icon.addEventListener('mouseenter', () => {
              // Activate icon on hover
              toggleState(icon, true);
          });
      
          icon.addEventListener('mouseleave', () => {
              // Restore icon to its state in the current cycle
              const isActive = activeIconIndices.includes(index);
              toggleState(icon, isActive);
          });
        });
        
      
      // Cycle through icon and line groups
      function cycle() {
        updateDisplay();
      
        currentIconGroupIndex = (currentIconGroupIndex + 1) % iconGroups.length;
        currentLineGroupIndex = (currentLineGroupIndex + 1) % lineGroups.length;
      
        cycleTimeout = setTimeout(cycle, 3000);
      }
      
      // Event listeners for steps
      steps.forEach((step, stepIndex) => {
        // step.addEventListener('mouseover', () => {
        //     steps.forEach(otherStep => {
        //         if (otherStep !== step) {
        //             otherStep.classList.add('greyed-out');
        //         }
        //     });
      
        //     // Stop the cycling animation
        //     if (cycleTimeout) {
        //         clearTimeout(cycleTimeout);
        //         cycleTimeout = null;
        //     }
      
        //     // Turn off all icons and lines
        //     figureIcons.forEach(icon => toggleState(icon, false));
        //     lineElements.forEach(line => (line.style.opacity = 0));
      
        //     // Activate icons for this step
        //     const iconsToActivate = stepIconMapping[stepIndex] || [];
        //     activeIconIndices = iconsToActivate.slice(); // Store active indices
        //     iconsToActivate.forEach(iconIndex => {
        //         const icon = figureIcons[iconIndex];
        //         toggleState(icon, true);
        //     });
        // });
      
        step.addEventListener('mouseout', () => {
            steps.forEach(otherStep => {
                otherStep.classList.remove('greyed-out');
            });
      
            // Resume the cycling animation
            if (!cycleTimeout) {
                cycle();
            }
        });
      });
      
      // Toggle state for icons
      function toggleState(icon, isActive) {
          const outlineIcon = icon.querySelector('.figure-icon-icon-outline');
          const solidIcon = icon.querySelector('.figure-icon-icon-solid');
          const label = icon.querySelector('.figure-icon-label');
      
          if (!outlineIcon || !solidIcon || !label) {
              console.error("Required elements are missing in the icon:", icon);
              return; // Prevent further execution
          }
      
          if (isActive) {
              solidIcon.style.opacity = 1;
              label.style.opacity = 1;
              outlineIcon.style.opacity = 0;
          } else {
              solidIcon.style.opacity = 0;
              label.style.opacity = 0;
              outlineIcon.style.opacity = 1;
          }
      }
      
      // Recalculate positions and redraw lines on resize
      window.addEventListener('resize', () => {
          generateLines();
          updateDisplay();
      });
      
      // Initial setup
      generateLines();
      cycle();

    // end Figure

    // Calculator functionality
    const calculator = {
        elements: {
            missedCallsInput: document.getElementById('missed-calls'),
            customerValueInput: document.getElementById('customer-value'),
            form: document.getElementById('calculator-form'),
            resultValue: document.getElementById('result-value'),
            monthlyValue: document.getElementById('monthly-value')
        },
        
        init() {
            // Add event listeners
            this.elements.missedCallsInput.addEventListener('input', () => this.updateCalculation());
            this.elements.customerValueInput.addEventListener('input', () => this.updateCalculation());
            this.elements.form.addEventListener('submit', (e) => e.preventDefault());
            
            // Initial calculation
            this.updateCalculation();
        },

        updateCalculation() {
            const dailyMissedCalls = parseFloat(this.elements.missedCallsInput.value) || 0;  
            const customerValue = parseFloat(this.elements.customerValueInput.value) || 0;    
            
            const monthlyMissedCalls = dailyMissedCalls * 31;
            const newCustomersRate = 0.30;
            const conversionRate = 0.70;
            const costPerCall = 0.75;
            
            const monthlyNewCustomers = Math.round(monthlyMissedCalls * newCustomersRate * conversionRate);
            const monthlyRevenue = monthlyNewCustomers * customerValue;
            const monthlyCosts = monthlyMissedCalls * costPerCall;
            const monthlyGain = Math.round(monthlyRevenue - monthlyCosts);
            const yearlyGain = monthlyGain * 12;
            
            this.elements.monthlyValue.textContent = monthlyGain.toLocaleString('fr-FR') + '€';
            this.elements.resultValue.textContent = yearlyGain.toLocaleString('fr-FR') + '€';
        }
    };

    // Initialize calculator if elements exist
    if (document.getElementById('calculator-form')) {
        calculator.init();
    }
});

